/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Injectable, Injector} from "@angular/core";
import {BaseHubService} from "../../hub-service-base.service";
import {SimUtilityService} from "../../../core/services/sim-services/sim-utility.service";
import {HubConnection} from "@microsoft/signalr";
import {CameraState} from "../model/camera-state";
import {ConnectedWebClient} from "../model/connected-web-client";
import {ConnectionMapping} from "../model/connection-mapping";
import {ConnectionStatus} from "../model/connection-status";
import {Device} from "../model/device";
import {DeviceActivityType} from "../model/device-activity-type";
import {DeviceData} from "../model/device-data";
import {DeviceSettings} from "../model/device-settings";
import {DeviceState} from "../model/device-state";
import {Event} from "../model/event";
import {EventState} from "../model/event-state";
import {IApplicationData} from "../model/i-application-data";
import {ISimSession} from "../model/i-sim-session";
import {LmsEntityStatus} from "../model/lms-entity-status";
import {MasterOfCeremonyMapping} from "../model/master-of-ceremony-mapping";
import {PlayerMapping} from "../model/player-mapping";
import {PowerDistributionUnit} from "../model/power-distribution-unit";
import {RecorderMapping} from "../model/recorder-mapping";
import {RoomChanged} from "../model/room-changed";
import {ScenarioRecording} from "../model/scenario-recording";
import {ScenarioRecordingGroup} from "../model/scenario-recording-group";
import {SimUser} from "../model/sim-user";
import {SimVersion} from "../model/sim-version";
import {SynchronizationJobInfo} from "../model/synchronization-job-info";
import {SystemStatusView} from "../model/system-status-view";
import {TabletMapping} from "../model/tablet-mapping";
import {TrainingRoom} from "../model/training-room";
import {TrainingRoomPcMapping} from "../model/training-room-pc-mapping";
import {TrainingSession} from "../model/training-session";
import {UserRecordingAssessment} from "../model/user-recording-assessment";
import {UserRecordingChecklist} from "../model/user-recording-checklist";
import {ViewingStationMapping} from "../model/viewing-station-mapping";
import {VogInTrainingRooms} from "../model/vog-in-training-rooms";
import {WebClientInfo} from "../model/web-client-info";

/**
 * Broadcasts information about changing states of player, tablet, web-recorder and many more.
 */ 

@Injectable({
    providedIn: "root",
})
export class SystemHub extends BaseHubService {
	protected readonly HubName: string = "SystemHub";

	constructor(_injector: Injector,
         protected _simUtilityService: SimUtilityService) {
        super(_injector);
	}

	protected wireOnMessage(connection: HubConnection) {
		connection.on("AlertWebRecorder", (webRecorderId: string, message: string) => {
            this._emitterService.onAlertWebRecorder.next({webRecorderId, message});
        });
		connection.on("ApplicationDataChanged", (applicationData: IApplicationData) => {
            this._emitterService.onApplicationDataChanged.next({applicationData});
        });
		connection.on("ApproveMapping", (connectionMapping: ConnectionMapping) => {
            this._emitterService.onApproveMapping.next({connectionMapping});
        });
		connection.on("CameraSettingsChanged", (cameraId: string) => {
            this._emitterService.onCameraSettingsChanged.next({cameraId});
        });
		connection.on("CameraStateChanged", (cameraState: CameraState) => {
            this._emitterService.onCameraStateChanged.next({cameraState});
        });
		connection.on("ConnectedTablet", (player: PlayerMapping, tablet: TabletMapping) => {
            this._emitterService.onConnectedTablet.next({player, tablet});
        });
		connection.on("ConnectedWebClientDelete", (connectedWebClient: ConnectedWebClient) => {
            this._emitterService.onConnectedWebClientDelete.next({connectedWebClient});
        });
		connection.on("ConnectedWebClientUpsert", (connectedWebClient: ConnectedWebClient) => {
            this._emitterService.onConnectedWebClientUpsert.next({connectedWebClient});
        });
		connection.on("ContinueTrainingSession", (trainingSessionId: string) => {
            this._emitterService.onContinueTrainingSession.next({trainingSessionId});
        });
		connection.on("DashboardTilesChanged", () => {
            this._emitterService.onDashboardTilesChanged.next();
        });
		connection.on("DeviceChanged", (device: Device) => {
            this._emitterService.onDeviceChanged.next({device});
        });
		connection.on("DeviceSettingChanged", (deviceSettings: DeviceSettings) => {
            this._emitterService.onDeviceSettingChanged.next({deviceSettings});
        });
		connection.on("DeviceStateChanged", (deviceState: DeviceState) => {
            this._emitterService.onDeviceStateChanged.next({deviceState});
        });
		connection.on("DisconnectTablet", (player: PlayerMapping, tablet: TabletMapping) => {
            this._emitterService.onDisconnectTablet.next({player, tablet});
        });
		connection.on("EventsChanged", () => {
            this._emitterService.onEventsChanged.next();
        });
		connection.on("EventStateChanged", (eventId: string, newState: EventState) => {
            this._emitterService.onEventStateChanged.next({eventId, newState});
        });
		connection.on("EventUpdated", (eventInfo: Event) => {
            this._emitterService.onEventUpdated.next({eventInfo});
        });
		connection.on("GroupRecordingStarted", (sessionRun: ScenarioRecordingGroup, trainingSession: TrainingSession) => {
            this._emitterService.onGroupRecordingStarted.next({sessionRun, trainingSession});
        });
		connection.on("GroupRecordingStopped", (sessionRun: ScenarioRecordingGroup, trainingSession: TrainingSession) => {
            this._emitterService.onGroupRecordingStopped.next({sessionRun, trainingSession});
        });
		connection.on("HealthReported", (systemStatusView: SystemStatusView) => {
            this._emitterService.onHealthReported.next({systemStatusView});
        });
		connection.on("LmsEntityStatusChanged", (status: LmsEntityStatus) => {
            this._emitterService.onLmsEntityStatusChanged.next({status});
        });
		connection.on("LocalizationChanged", (language: string, localizationKey: string, value: string) => {
            this._emitterService.onLocalizationChanged.next({language, localizationKey, value});
        });
		connection.on("MoCStateChanged", (recorder: MasterOfCeremonyMapping) => {
            this._emitterService.onMoCStateChanged.next({recorder});
        });
		connection.on("NewUpdateAvailable", (versionNumber: SimVersion) => {
            this._emitterService.onNewUpdateAvailable.next({versionNumber});
        });
		connection.on("NotifyConversionProgress", () => {
            this._emitterService.onNotifyConversionProgress.next();
        });
		connection.on("NotifyExportProgress", () => {
            this._emitterService.onNotifyExportProgress.next();
        });
		connection.on("NotifyNotificationAdded", () => {
            this._emitterService.onNotifyNotificationAdded.next();
        });
		connection.on("OsceVogMediaBroadcastClosed", (webRecorderId: string, trainingRoomIds: string[], isPartialClose: boolean) => {
            this._emitterService.onOsceVogMediaBroadcastClosed.next({webRecorderId, trainingRoomIds, isPartialClose});
        });
		connection.on("OsceVogMediaBroadcastOpened", (webRecorderId: string, trainingRoomIds: string[], mediaId: string) => {
            this._emitterService.onOsceVogMediaBroadcastOpened.next({webRecorderId, trainingRoomIds, mediaId});
        });
		connection.on("OsceVogMicrophoneBroadcastClosed", (webRecorderId: string, trainingRoomIds: string[], isPartialClose: boolean) => {
            this._emitterService.onOsceVogMicrophoneBroadcastClosed.next({webRecorderId, trainingRoomIds, isPartialClose});
        });
		connection.on("OsceVogMicrophoneBroadcastOpened", (webRecorderId: string, trainingRoomIds: string[], isPartialClose: boolean) => {
            this._emitterService.onOsceVogMicrophoneBroadcastOpened.next({webRecorderId, trainingRoomIds, isPartialClose});
        });
		connection.on("PlayerStateChanged", (player: PlayerMapping) => {
            this._emitterService.onPlayerStateChanged.next({player});
        });
		connection.on("PowerDistributionUnitChanged", (powerDistributionUnit: PowerDistributionUnit) => {
            this._emitterService.onPowerDistributionUnitChanged.next({powerDistributionUnit});
        });
		connection.on("RecordingAborted", (webRecorderId: string, scenarioRecording: ScenarioRecording) => {
            this._emitterService.onRecordingAborted.next({webRecorderId, scenarioRecording});
        });
		connection.on("RecordingStarted", (recorder: RecorderMapping, scenarioRecording: ScenarioRecording, trainingSession: TrainingSession) => {
            this._emitterService.onRecordingStarted.next({recorder, scenarioRecording, trainingSession});
        });
		connection.on("RecordingStopped", (webRecorderId: string, scenarioRecording: ScenarioRecording, stoppedByUser: SimUser, stoppedByService: boolean) => {
            this._emitterService.onRecordingStopped.next({webRecorderId, scenarioRecording, stoppedByUser, stoppedByService});
        });
		connection.on("RedirectClient", (url: string) => {
            this._emitterService.onRedirectClient.next({url});
        });
		connection.on("ReloadClient", () => {
            this._emitterService.onReloadClient.next();
        });
		connection.on("RemoteExaminerRoomCountChanged", (count: number, trainingRoomId: string) => {
            this._emitterService.onRemoteExaminerRoomCountChanged.next({count, trainingRoomId});
        });
		connection.on("ReserveBusyPlayer", (playerId: string, recorderMappingId: string) => {
            this._emitterService.onReserveBusyPlayer.next({playerId, recorderMappingId});
        });
		connection.on("RevokeMapping", (mappingId: string) => {
            this._emitterService.onRevokeMapping.next({mappingId});
        });
		connection.on("ScenarioRecordingChanged", (scenarioRecordingId: string) => {
            this._emitterService.onScenarioRecordingChanged.next({scenarioRecordingId});
        });
		connection.on("ScenarioRecordingDownloadProgressChanged", (scenarioRecordingId: string, progress: number) => {
            this._emitterService.onScenarioRecordingDownloadProgressChanged.next({scenarioRecordingId, progress});
        });
		connection.on("ScenarioRecordingGroupChanged", (webRecorderId: string, scenarioRecordingGroup: ScenarioRecordingGroup) => {
            this._emitterService.onScenarioRecordingGroupChanged.next({webRecorderId, scenarioRecordingGroup});
        });
		connection.on("ScenarioRecordingIsReadyForArchive", (scenarioRecordingId: string) => {
            this._emitterService.onScenarioRecordingIsReadyForArchive.next({scenarioRecordingId});
        });
		connection.on("SettingsChanged", () => {
            this._emitterService.onSettingsChanged.next();
        });
		connection.on("ShouldStartRecording", (webRecorderId: string, scenarioRecordingId: string) => {
            this._emitterService.onShouldStartRecording.next({webRecorderId, scenarioRecordingId});
        });
		connection.on("SimStationUpdateDownloadProgress", (downloadProgress: number) => {
            this._emitterService.onSimStationUpdateDownloadProgress.next({downloadProgress});
        });
		connection.on("SimStationUpdateFinished", (updateFinished: boolean) => {
            this._emitterService.onSimStationUpdateFinished.next({updateFinished});
        });
		connection.on("StartDebriefing", (player: PlayerMapping, debriefingTablet: TabletMapping) => {
            this._emitterService.onStartDebriefing.next({player, debriefingTablet});
        });
		connection.on("StartMediaAnnouncement", (mediaId: string) => {
            this._emitterService.onStartMediaAnnouncement.next({mediaId});
        });
		connection.on("StopDebriefing", (player: PlayerMapping) => {
            this._emitterService.onStopDebriefing.next({player});
        });
		connection.on("SwitchEnvironment", (domain: string) => {
            this._emitterService.onSwitchEnvironment.next({domain});
        });
		connection.on("SynchronizationJobInfoChanged", (synchronizationJobInfo: SynchronizationJobInfo) => {
            this._emitterService.onSynchronizationJobInfoChanged.next({synchronizationJobInfo});
        });
		connection.on("SystemShutdownImminent", (triggerKey: string) => {
            this._emitterService.onSystemShutdownImminent.next({triggerKey});
        });
		connection.on("TabletStateChanged", (tablet: TabletMapping) => {
            this._emitterService.onTabletStateChanged.next({tablet});
        });
		connection.on("TakeAwayPlayers", (playerIds: string[]) => {
            this._emitterService.onTakeAwayPlayers.next({playerIds});
        });
		connection.on("TestMessage", (message: string) => {
            this._emitterService.onTestMessage.next({message});
        });
		connection.on("TrainingRoomChanged", (roomChanged: RoomChanged) => {
            this._emitterService.onTrainingRoomChanged.next({roomChanged});
        });
		connection.on("TrainingRoomEntranceStateChanged", (trainingRoomPcMapping: TrainingRoomPcMapping) => {
            this._emitterService.onTrainingRoomEntranceStateChanged.next({trainingRoomPcMapping});
        });
		connection.on("TrainingRoomPresetCameraLayoutChanged", (trainingRoomId: string) => {
            this._emitterService.onTrainingRoomPresetCameraLayoutChanged.next({trainingRoomId});
        });
		connection.on("TrainingRoomUpdate", (trainingRoom: TrainingRoom) => {
            this._emitterService.onTrainingRoomUpdate.next({trainingRoom});
        });
		connection.on("TrainingSessionUpdated", (simSession: ISimSession) => {
            this._emitterService.onTrainingSessionUpdated.next({simSession});
        });
		connection.on("UserRecordingAssessmentChanged", (userRecordingAssessment: UserRecordingAssessment) => {
            this._emitterService.onUserRecordingAssessmentChanged.next({userRecordingAssessment});
        });
		connection.on("UserRecordingChecklistChanged", (userRecordingChecklist: UserRecordingChecklist) => {
            this._emitterService.onUserRecordingChecklistChanged.next({userRecordingChecklist});
        });
		connection.on("ViewingStationStateChanged", (viewingStation: ViewingStationMapping) => {
            this._emitterService.onViewingStationStateChanged.next({viewingStation});
        });
		connection.on("VogInTrainingRoomsChanged", (vogInTrainingRooms: VogInTrainingRooms) => {
            this._emitterService.onVogInTrainingRoomsChanged.next({vogInTrainingRooms});
        });
		connection.on("WebClientStateChanged", (webClientInfo: WebClientInfo) => {
            this._emitterService.onWebClientStateChanged.next({webClientInfo});
        });
		connection.on("WebRecorderStateChanged", (recorder: RecorderMapping) => {
            this._emitterService.onWebRecorderStateChanged.next({recorder});
        });
    }

	protected connectionDisconnectedAction(): void {
        this._emitterService.onSystemHubDisconnected.next();
	}

	protected connectionErrorAction(message: string): void {
        this._emitterService.onSystemHubError.next({message});
	}

	protected connectionFirstConnectedAction(connectionId: string): void {
        this._emitterService.onSystemHubConnected.next({connectionId});
	}

	protected connectionReconnectedAction(connectionId: string): void {
        this._emitterService.onSystemHubReconnected.next({connectionId});
	}

    public addToGroup(topic: DeviceActivityType, topicId: string): Promise<void> {
        return this.invoke<void>("AddToGroup", topic, topicId);
    }

    public checkAuthentication(): Promise<boolean> {
        return this.invoke<boolean>("CheckAuthentication", );
    }

    public clearConfigurationCache(): Promise<void> {
        return this.invoke<void>("ClearConfigurationCache", );
    }

    public removeFromGroup(topic: DeviceActivityType, topicId: string): Promise<void> {
        return this.invoke<void>("RemoveFromGroup", topic, topicId);
    }

    public updateConnection(status: ConnectionStatus): Promise<void> {
        return this.invoke<void>("UpdateConnection", status);
    }

    public updateDeviceData(deviceData: DeviceData): Promise<void> {
        return this.invoke<void>("UpdateDeviceData", deviceData);
    }

    public updatePlayerState(player: PlayerMapping): Promise<void> {
        return this.invoke<void>("UpdatePlayerState", player);
    }

    public updatePlayingVogMedia(webRecorderId: string, mediaId: string, progress: number): Promise<void> {
        return this.invoke<void>("UpdatePlayingVogMedia", webRecorderId, mediaId, progress);
    }

    public updatePlayingVopMedia(webRecorderId: string, mediaId: string, progress: number): Promise<void> {
        return this.invoke<void>("UpdatePlayingVopMedia", webRecorderId, mediaId, progress);
    }

    public updateRecorderMappingVogMediaHasStopped(recorderId: string, mediaId: string): Promise<void> {
        return this.invoke<void>("UpdateRecorderMappingVogMediaHasStopped", recorderId, mediaId);
    }

    public updateRecorderMappingVopMediaHasStopped(recorderId: string, mediaId: string): Promise<void> {
        return this.invoke<void>("UpdateRecorderMappingVopMediaHasStopped", recorderId, mediaId);
    }

    public updateTrainingRoomEntranceState(trainingRoomPcMapping: TrainingRoomPcMapping): Promise<void> {
        return this.invoke<void>("UpdateTrainingRoomEntranceState", trainingRoomPcMapping);
    }

    public updateViewingStationState(viewingStation: ViewingStationMapping): Promise<void> {
        return this.invoke<void>("UpdateViewingStationState", viewingStation);
    }

    public updateWebRecorderState(recorder: RecorderMapping): Promise<void> {
        return this.invoke<void>("UpdateWebRecorderState", recorder);
    }
}
